import type { ReactNode } from 'react'
import { Filter } from 'lucide-react'
import { Button } from './Button'
import { cn } from '@/lib/cn'

interface Props {
  /**
   * Quando definido, mostra um botão "Filtros" no canto direito do toolbar
   * (regra global #2). O clique abre o FilterDrawer da página, que contém
   * TODOS os filtros inclusive a busca textual.
   */
  onFiltersClick?: () => void
  /** Quantidade de filtros ativos — exibe bolha colorida no botão. */
  activeFiltersCount?: number
  children?: ReactNode
  className?: string
}

/**
 * Toolbar minimalista: ações livres à esquerda + botão "Filtros" à direita.
 *
 * Conforme a regra global #2, NÃO há input de busca inline aqui — todos os
 * filtros (incluindo busca textual) ficam dentro do FilterDrawer.
 */
export function Toolbar({ onFiltersClick, activeFiltersCount, children, className }: Props) {
  return (
    <div className={cn('flex flex-wrap items-center gap-3 mb-3', className)}>
      <div className="flex items-center gap-2">{children}</div>
      {onFiltersClick && (
        <div className="ml-auto">
          <Button variant="secondary" onClick={onFiltersClick} iconLeft={<Filter size={14} />}>
            Filtros
            {!!activeFiltersCount && activeFiltersCount > 0 && (
              <span className="ml-1.5 inline-flex items-center justify-center min-w-[18px] h-5 px-1.5 rounded-full bg-brand-500 text-white text-[10px] font-semibold">
                {activeFiltersCount}
              </span>
            )}
          </Button>
        </div>
      )}
    </div>
  )
}
